/**
 * User Preferences Service
 *
 * API client for the /user-preferences/ endpoint.
 *
 * NOTE: The backend does a shallow merge of `preferences` on PUT —
 * top-level keys you send replace the stored value, keys you omit are kept.
 * Nested objects (e.g. notifications) are NOT deep-merged, so always spread
 * the full nested object before sending.
 */

import { fetchApi } from '@/shared/services/api';
import type { UserPreferencesRead, UserPreferencesUpdate } from '@/shared/types';

export const userPreferencesService = {
  get: () => fetchApi<UserPreferencesRead>('/user-preferences/'),

  update: (data: UserPreferencesUpdate) =>
    fetchApi<UserPreferencesRead>('/user-preferences/', {
      method: 'PUT',
      body: data,
    }),
};
